import { build_ts, build_day_ts, build_day, parseTime } from "@/utils";
import { LuxonTime, pickerUtils } from "common";
import store from "@/store";
export const timeRnage = {
  data() {
    return {
      pickerOptions_start: {
        firstDayOfWeek: 1,
        disabledDate: (time) => this.disabledDate(time),
        // disabledDate(time) {
        //     let org_start = localStorage.getItem("defaultStartMonth");
        //     let org_end = localStorage.getItem("defaultEndMonth");
        //     if (store.state.user.urlParams.fusion_plat) {
        //       org_start = localStorage.getItem("fusionDefaultStartMonth");
        //       org_end = localStorage.getItem("fusiondefaultEndMonth");
        //     }
        //     let result_start = org_start;
        //     let result_end = org_end;
        //     const { start, end } = store.state.user.loginInfo;
        //     const { tsType } = store.state.user;

        //     if (start && start !== org_start) {
        //       if (LuxonTime.getTimeTs(start) > LuxonTime.getTimeTs(org_start)) {
        //         result_start = start;
        //       }
        //     }
        //     if (end && end !== org_end) {
        //       if (LuxonTime.getTimeTs(end) < LuxonTime.getTimeTs(org_end)) {
        //         result_end = end;
        //       }
        //     }
        //     if (tsType == "month") {
        //       if (result_start != result_end) {
        //         //如果不加.replace(/-/g, "/") new Date出来的的日期是8点钟而不是0点
        //         if (time < new Date(result_start.replace(/-/g, "/"))) {
        //           return true;
        //         } else if (time > new Date(result_end.replace(/-/g, "/"))) {
        //           return true;
        //         } else {
        //           return false;
        //         }
        //       } else {
        //         if (
        //           time.getMonth() ==
        //           new Date(result_start.replace(/-/g, "/")).getMonth()
        //         ) {
        //           return false;
        //         } else {
        //           return true;
        //         }
        //       }
        //     } else {
        //       let result_start_day = result_start.split('-')[0] + '-' + (Number(result_start.split('-')[1]) + 1)
        //       let result_end_day = result_end.split('-')[0] + '-' + (Number(result_end.split('-')[1]) + 1)
        //       if (result_start != result_end) {
        //         //如果不加.replace(/-/g, "/") new Date出来的的日期是8点钟而不是0点
        //         if (
        //           time.getTime() <
        //           new Date(result_start_day.replace(/-/g, "/")).getTime()
        //         ) {
        //           // console.log(time.getTime(), new Date(result_start_day.replace(/-/g, "/")).getTime())
        //           console.log(time, result_start_day)
        //           console.log(LuxonTime.getTimeTs(time), LuxonTime.getTimeTs(result_start_day))
        //           return true;
        //         } else if (
        //           time.getTime() >
        //           new Date(result_end_day.replace(/-/g, "/")).getTime()
        //         ) {
        //           return true;
        //         } else {
        //           return false;
        //         }
        //       } else {
        //         if (
        //           time.getTime() ==
        //           new Date(result_start_day.replace(/-/g, "/")).getTime()
        //         ) {
        //           return false;
        //         } else {
        //           return true;
        //         }
        //       }
        //     }
        // },
      },
      pickerOptions_end: {
        disabledDate(time) {
          let org_start = localStorage.getItem("defaultStartMonth");
          let org_end = localStorage.getItem("defaultEndMonth");
          if (org_start != org_end) {
            if (time < new Date(org_start.replace(/-/g, "/"))) {
              return true;
            } else if (time > new Date(org_end)) {
              return true;
            } else {
              return false;
            }
          } else {
            if (time.getMonth() == new Date(org_start).getMonth()) {
              return false;
            } else {
              return true;
            }
          }
        },
      },
    };
  },
  methods: {
    disabledDate(date) {
      let org_start = localStorage.getItem("defaultStartMonth");
      let org_end = localStorage.getItem("defaultEndMonth");
      if (this.$store.state.user.urlParams.fusion_plat) {
        org_start = localStorage.getItem("fusionDefaultStartMonth");
        org_end = localStorage.getItem("fusiondefaultEndMonth");
      }
      let result_start = org_start;
      let result_end = org_end;
      const { start, end } = this.$store.state.user.loginInfo;
      const { tsType } = this.$store.state.user;

      if (start && start !== org_start) {
        if (LuxonTime.getTimeTs(start) > LuxonTime.getTimeTs(org_start)) {
          result_start = start;
        }
      }
      if (end && end !== org_end) {
        if (LuxonTime.getTimeTs(end) < LuxonTime.getTimeTs(org_end)) {
          result_end = end;
        }
      }
      let times = this.formatDate(date, "{y}-{m}");
      if (tsType == "week") {
        times = this.formatDate(date, "{y}-{m}-{d}");
        //方案一选择周度时，可选时间范围为用户权限最早年月的第一天所在周的周一到最大年月最后一天所在周的周日(向外兼容)
        // let firstDay = this.getFirstAndLastDayOfMonth(
        //   result_start.split("-")[0],
        //   result_start.split("-")[1]
        // ).firstDay;
        // let lastDay = this.getFirstAndLastDayOfMonth(
        //   org_end.split("-")[0],
        //   org_end.split("-")[1]
        // ).lastDay;
        // let fDay = this.getFirstAndLastWeekOfMonth(firstDay).monday;
        // let lDay = this.getFirstAndLastWeekOfMonth(lastDay).sunday;
        //方案二：可选时间范围为用户权限最早年月的所在月份第一个完整周的开始日期到最大年月的所在月份最后一个完整周的结束日期(向内兼容)
        let firstDay = this.getFirstAndLastCompleteWeeks(
          result_start.split("-")[0],
          result_start.split("-")[1]
        ).firstCompleteWeek.start;
        let lastDay = this.getFirstAndLastCompleteWeeks(
          org_end.split("-")[0],
          org_end.split("-")[1]
        ).lastCompleteWeek.end;
        let fDay = pickerUtils.formatDate(firstDay, "{y}-{m}-{d}");
        let lDay = pickerUtils.formatDate(lastDay, "{y}-{m}-{d}");
        return times > lDay || times < fDay;
      } else if (tsType == "day") {
        times = this.formatDate(date, "{y}-{m}-{d}");
        return (
          //第一项为最大时间，最后一项为最小时间
          times >
            this.getFirstAndLastDayOfMonth(
              org_end.split("-")[0],
              org_end.split("-")[1]
            ).lastDay ||
          times <
            this.getFirstAndLastDayOfMonth(
              result_start.split("-")[0],
              result_start.split("-")[1]
            ).firstDay
        );
      } else {
        if (result_start != result_end) {
          //如果不加.replace(/-/g, "/") new Date出来的的日期是8点钟而不是0点
          if (date < new Date(result_start.replace(/-/g, "/"))) {
            return true;
          } else if (date > new Date(result_end.replace(/-/g, "/"))) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            date.getMonth() ==
            new Date(result_start.replace(/-/g, "/")).getMonth()
          ) {
            return false;
          } else {
            return true;
          }
        }
      }
    },
    formatDate(date, cFormat) {
      const format = cFormat || "{y}-{m}-{d}";
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const formatObj = {
        y: year,
        m: month,
        d: day,
      };
      const time_str = format.replace(/{([ymd])+}/g, (result, key) => {
        const value = formatObj[key];
        return value.toString();
      });
      return time_str;
    },
    getFirstAndLastWeekOfMonth(date) {
      let currentDate = new Date(date.replace(/-/g, "/"));
      let currentTime = currentDate.getTime();
      let currentDay = currentDate.getDay();
      let dayTime = 24 * 60 * 60 * 1000;
      let monday = currentTime - (currentDay - 1) * dayTime;
      let sunday = currentTime + (7 - currentDay) * dayTime;
      return {
        monday: pickerUtils.formatDate(new Date(monday), "{y}-{m}-{d}"),
        sunday: pickerUtils.formatDate(new Date(sunday), "{y}-{m}-{d}"),
      };
    },
    getFirstAndLastDayOfMonth(year, month) {
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);

      return {
        firstDay: pickerUtils.formatDate(firstDay, "{y}-{m}-{d}"),
        lastDay: pickerUtils.formatDate(lastDay, "{y}-{m}-{d}"),
      };
    },
    getFirstAndLastCompleteWeeks(year, month) {
      //根据年月获取该月第一个完整周的起始日期和该月最后一个完整周的起始日期
      // 获取该月份的第一天和最后一天
      const firstDay = new Date(year, month - 1, 1);
      const lastDay = new Date(year, month, 0);
      // 获取该月份第一天是星期几（0-6，0是星期日）
      const firstDayOfWeek = firstDay.getDay();
      // 获取该月份最后一天是星期几
      const lastDayOfWeek = lastDay.getDay();
      // 计算第一个完整周的开始和结束日期
      let firstWeekStart = new Date(firstDay);
      let firstWeekEnd = new Date(firstDay);
      if (firstDayOfWeek != 1) {
        //如果不是周一就需要往后推一周
        firstWeekStart.setDate(firstDay.getDate() + 7 - firstDayOfWeek + 1);
        firstWeekEnd.setDate(firstDay.getDate() + 14 - firstDayOfWeek);
      } else {
        firstWeekStart.setDate(firstDay.getDate() - firstDayOfWeek + 1);
        firstWeekEnd.setDate(firstDay.getDate() + 7 - firstDayOfWeek);
      }
      // 计算最后一个完整周的开始和结束日期
      let lastWeekStart = new Date(lastDay);
      let lastWeekEnd = new Date(lastDay);
      if (lastDayOfWeek != 0) {
        //如果不是周日就需要往前推一周
        lastWeekStart.setDate(lastDay.getDate() - 7 - lastDayOfWeek + 1);
        lastWeekEnd.setDate(lastDay.getDate() - lastDayOfWeek);
      } else {
        lastWeekStart.setDate(lastDay.getDate() - lastDayOfWeek + 1);
        lastWeekEnd.setDate(lastDay.getDate() + 7 - lastDayOfWeek);
      }
      return {
        firstCompleteWeek: {
          start: firstWeekStart,
          end: firstWeekEnd,
        },
        lastCompleteWeek: {
          start: lastWeekStart,
          end: lastWeekEnd,
        },
      };
    },
  },
};

export const listenObj = {
  data() {
    return {};
  },
  computed: {
    listenObj() {
      return {
        plat: this.$store.state.user.plants,
        kol_type: this.$store.state.user.kolType,
        brand_name: this.$store.state.user.brandName,
        start: this.$store.state.user.startMonth,
        end: this.$store.state.user.endMonth,
        word: this.$store.state.user.selectedKeyWards,
        kol_id: this.$store.state.user.KolId,
        kol_name: this.$store.state.user.KolName,
        cat_id: this.$store.state.user.catId,
        rule_id: this.$store.state.user.ruleId,
        cat_name: this.$store.state.user.catName,
        analyse_typ: this.$store.state.user.analyseTyp,
        r_rule_id: this.$store.state.user.routerRuleId,
        words: this.$store.state.user.words,
        r_analyse_typ: this.$store.state.user.routerAnalyseTyp,
        label_level: this.$store.state.user.labelLevel,
        aspect_type: this.$store.state.user.aspectType,
      };
    },
  },
  watch: {
    listenObj: {
      handler(newVal, oldVal) {
        if (
          JSON.stringify(newVal ? newVal : "") !==
          JSON.stringify(oldVal ? oldVal : "")
        ) {
          //   this.$router.push({
          //     name: this.$route.name,
          //     query: {
          //       plat: this.$store.state.user.plants
          //         ? this.$store.state.user.plants.join(",")
          //         : "",
          //       brand_id: this.$store.state.user.selectedType
          //         ? this.$store.state.user.selectedType.join(",")
          //         : "",
          //       start: parseTime(this.$store.state.user.startMonth, "{y}-{m}"),
          //       end: parseTime(this.$store.state.user.endMonth, "{y}-{m}"),
          //       word: this.$store.state.user.selectedKeyWards,
          //       kol_id: this.$store.state.user.KolId,
          //       kol_name: this.$store.state.user.KolName,
          //       cat_id: this.$store.state.user.catId,
          //       rule_id: this.$store.state.user.ruleId,
          //       cat_name: this.$store.state.user.catName,
          //       analyse_typ: this.$store.state.user.analyseTyp,
          //       r_rule_id: this.$store.state.user.routerRuleId,
          //       words: this.$store.state.user.words,
          //       r_analyse_typ: this.$store.state.user.routerAnalyseTyp,
          //       label_level: this.$store.state.user.labelLevel,
          //       aspect_type: this.$store.state.user.aspectType,
          //       kol_type: this.$store.state.user.kolType
          //         ? this.$store.state.user.kolType.join(",")
          //         : "",
          //     },
          //   });
        }
      },
      deep: true,
    },
  },
};
